import styles from "./PageShell.module.scss";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import BasicInformation from "./BasicInformation";
import AddressDetails from "./AddressDetails";
import JobInformation from "./JobInformation";
import IdVerification from "./IdVerification";
import BankDetails from "./BankDetails";
import EducationDetails from "./EducationDetails";
import PreviousEmploymentDetails from "./PreviousEmploymentDetails";
import DeclarationForm from "./DeclarationForm";
import EsiForm from "./EsiForm";
// import ReviewPage from "./ReviewPage";
// import udsLogo from "../../assets/udslogo.svg";
import Logo from "../../../Assets/logo.png";
import { setSignatureEmployeeRetrieveAction } from "../../../Redux/Slice";
import { updateBasicField } from "../../../Redux/employeeInformationSlice";

const steps = Array.from({ length: 9 }, (_, index) => index + 1);

export default function PageShell({ onPrevious = () => {} }) {
  const esignatureId = "1030123";

  const dispatch = useDispatch();
  const employeeDetails = useSelector(
    (state) =>
      state.Signature_Employee_RetrieveCall_actions?.Signature_Employee_Datas,
  );
  const retrieveError = useSelector(
    (state) => state.Signature_Employee_RetrieveCall_actions?.Error,
  );
  const basicInformationRef = useRef(null);
  const addressDetailsRef = useRef(null);
  const jobInformationRef = useRef(null);
  const idVerificationRef = useRef(null);
  const bankDetailsRef = useRef(null);
  //   const educationRef = useRef(null);
  const educationDetailsRef = useRef(null);
  const previousEmploymentDetailsRef = useRef(null);
  const declarationformRef = useRef(null);
  const esiRef = useRef(null);
  const hasPrefilledRef = useRef(false);
  const [activeStep, setActiveStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [toast, setToast] = useState("");

  // useEffect(() => {
  //   if (esignatureId) {
  //     dispatch(
  //       setSignatureEmployeeRetrieveAction({ timeline_id: esignatureId }),
  //     );
  //   }
  // }, [dispatch, esignatureId]);

  useEffect(() => {
    // if (!employeeDetails || hasPrefilledRef.current) {
    //   return;
    // }

    const basicFieldMap = {
      // name:
      //   employeeDetails?.first_name ||
      //   employeeDetails?.user_id__first_name ||
      //   employeeDetails?.user__first_name ||
      //   "",
      // phoneNumber:
      //   employeeDetails?.phone_number ||
      //   employeeDetails?.user_id__phone_number ||
      //   employeeDetails?.mobile_number ||
      //   "",
      // email:
      //   employeeDetails?.email_id ||
      //   employeeDetails?.email ||
      //   employeeDetails?.user_id__email ||
      //   "",
      // aadhaarNumber:
      //   employeeDetails?.aadhar_number ||
      //   employeeDetails?.aadhaar_number ||
      //   "",
      // dateOfBirth: employeeDetails?.date_of_birth || employeeDetails?.dob || "",
      // gender: employeeDetails?.gender || "",

      first_name:
        employeeDetails?.first_name ||
        employeeDetails?.user_id__first_name ||
        employeeDetails?.user__first_name ||
        "",

      phoneNum:
        employeeDetails?.phone_number ||
        employeeDetails?.user_id__phone_number ||
        employeeDetails?.mobile_number ||
        "",

      email_id:
        employeeDetails?.email_id ||
        employeeDetails?.email ||
        employeeDetails?.user_id__email ||
        "",

      aadhar_number:
        employeeDetails?.aadhar_number || employeeDetails?.aadhaar_number || "",

      DateofBirth: employeeDetails?.date_of_birth || employeeDetails?.dob || "",

      placeofBirth: employeeDetails?.place_of_birth || "",

      gender: employeeDetails?.gender || "",
    };

    Object.entries(basicFieldMap).forEach(([name, value]) => {
      if (value) {
        dispatch(updateBasicField({ name, value }));
      }
    });

    hasPrefilledRef.current = true;
  }, [dispatch, employeeDetails]);

  const isOfferVerified =
    employeeDetails?.whatsapp_offer_letter_verified === true ||
    String(employeeDetails?.whatsapp_offer_letter_verified) === "true" ||
    String(employeeDetails?.whatsapp_offer_letter_verified) === "1";
  const isSigned =
    isOfferVerified && String(employeeDetails?.whatsapp_sign_status) === "1";
  const isRejected = String(employeeDetails?.whatsapp_sign_status) === "2";
  const isUnsigned = String(employeeDetails?.whatsapp_sign_status) === "0";

  const showToast = (message) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 3000);
  };

  const formatMissingMessage = (title, missingFields) => {
    const visibleMissingFields = missingFields.slice(0, 4).join(", ");
    const extraCount = missingFields.length - 4;

    return `${title}: ${visibleMissingFields}${
      extraCount > 0 ? ` and ${extraCount} more` : ""
    }.`;
  };

  const completeBasicInformation = () => {
    const missingFields = basicInformationRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(
        formatMissingMessage("Missing Basic Information", missingFields),
      );
      return false;
    }

    setCompletedSteps((currentSteps) =>
      currentSteps.includes(1) ? currentSteps : [...currentSteps, 1],
    );
    return true;
  };

  const completeAddressDetails = () => {
    const missingFields = addressDetailsRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(formatMissingMessage("Missing Address Details", missingFields));
      return false;
    }

    setCompletedSteps((currentSteps) =>
      currentSteps.includes(2) ? currentSteps : [...currentSteps, 2],
    );
    return true;
  };

  const completeJobInformation = () => {
    const missingFields = jobInformationRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(formatMissingMessage("Missing Job Information", missingFields));
      return false;
    }

    setCompletedSteps((currentSteps) =>
      currentSteps.includes(3) ? currentSteps : [...currentSteps, 3],
    );
    return true;
  };

  const completeIdVerification = () => {
    const missingFields = idVerificationRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(formatMissingMessage("Missing ID Verification", missingFields));
      return false;
    }

    setCompletedSteps((steps) => (steps.includes(4) ? steps : [...steps, 4]));

    return true;
  };

  const completeBankDetails = () => {
    const missing = bankDetailsRef.current?.getMissingFields() || [];

    if (missing.length > 0) {
      showToast(formatMissingMessage("Missing Bank Details", missing));
      return false;
    }

    setCompletedSteps((s) => (s.includes(5) ? s : [...s, 5]));

    return true;
  };

  const completeEducationDetails = () => {
    const missingFields = educationDetailsRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(
        formatMissingMessage("Missing Education Details", missingFields),
      );
      return false;
    }

    setCompletedSteps((steps) => (steps.includes(6) ? steps : [...steps, 6]));

    return true;
  };

  const completePreviousEmploymentDetails = () => {
    const missingFields =
      previousEmploymentDetailsRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(
        formatMissingMessage(
          "Missing Previous Employment Details",
          missingFields,
        ),
      );
      return false;
    }

    setCompletedSteps((steps) => (steps.includes(7) ? steps : [...steps, 7]));

    return true;
  };

  const completeDeclarationForm = () => {
    const missingFields = declarationformRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(formatMissingMessage("Missing Details", missingFields));
      return false;
    }

    setCompletedSteps((steps) => (steps.includes(8) ? steps : [...steps, 8]));

    return true; // ✅ THIS WAS MISSING
  };

  const completeEsi = () => {
    const missing = esiRef.current?.getMissingFields() || [];

    if (missing.length > 0) {
      showToast(formatMissingMessage("Missing ESI Details", missing));
      return false;
    }

    setCompletedSteps((s) => (s.includes(9) ? s : [...s, 9]));

    return true;
  };

  const handleSaveContinue = () => {
    if (activeStep === 1) {
      setActiveStep(2);
      return;
    }
    console.log(activeStep, "Daskldalkdlka");
    if (activeStep === 2) {
      setActiveStep(3);
      return;
    }

    if (activeStep === 3) {
      setActiveStep(4);
    }

    if (activeStep === 4) {
      setActiveStep(5);
    }

    if (activeStep === 5) {
      setActiveStep(6);
    }
    if (activeStep === 6) {
      setActiveStep(7);
    }
    if (activeStep === 7) {
      setActiveStep(8);
    }

    if (activeStep === 8) {
      setActiveStep(9);
    }
    console.log(activeStep, "Daskldalkdlka");
    if (activeStep === 9) {
      // setActiveStep(10); // 👈 go to review page
      console.log("final submit");
      return;
    }
  };

  const handlePrevious = () => {
    if (activeStep === 1) {
      onPrevious();
      return;
    }

    setActiveStep((currentStep) => currentStep - 1);
  };

  const handleTimelineClick = (step) => {
    console.log(step, "djaskajkaj");
    if (step === activeStep) {
      return;
    }

    if (step === 1 || completedSteps.includes(step)) {
      setActiveStep(step);
      return;
    }

    if (step === 2 || completeBasicInformation()) {
      setActiveStep(2);
      return;
    }

    if (step === 3 || completeAddressDetails()) {
      setActiveStep(3);
      return;
    }

    if (step === 4 || completeJobInformation()) {
      setActiveStep(4);
    }

    if (activeStep === 5) {
      return <BankDetails ref={bankDetailsRef} />;
    }

    if (step === 6 || completeBankDetails()) {
      setActiveStep(6);
      return;
    }

    if (step === 7 || completeEducationDetails()) {
      setActiveStep(7);
      return;
    }

    if (step === 8 || completePreviousEmploymentDetails()) {
      setActiveStep(8);
      return;
    }

    if (step === 9 || completeDeclarationForm()) {
      setActiveStep(9);
      return;
    }
    if (activeStep === 9) {
      return <EsiForm ref={esiRef} />;
    }
  };

  const renderActiveStep = () => {
    if (activeStep === 1) {
      return <BasicInformation ref={basicInformationRef} />;
    }

    if (activeStep === 2) {
      return <AddressDetails ref={addressDetailsRef} />;
    }

    if (activeStep === 3) {
      return <JobInformation ref={jobInformationRef} />;
    }

    if (activeStep === 4) {
      return <IdVerification ref={idVerificationRef} />;
    }

    if (activeStep === 5) {
      return <BankDetails ref={bankDetailsRef} />;
    }

    if (activeStep === 6) {
      return <EducationDetails ref={educationDetailsRef} />;
    }

    if (activeStep === 7) {
      return <PreviousEmploymentDetails ref={previousEmploymentDetailsRef} />;
    }
    if (activeStep === 8) {
      return <DeclarationForm ref={declarationformRef} />;
    }

    if (activeStep === 9) {
      return <EsiForm ref={esiRef} />;
    }
    // if (activeStep === 10) {
    //   return <ReviewPage onEdit={handleEditFromReview} />;
    // }

    return (
      <div className={styles.stepPlaceholder}>
        <h2>Step {activeStep}</h2>
      </div>
    );
  };

  // if (!esignatureId) {
  //   return (
  //     <main className={styles.pageShell}>
  //       <section className={styles.statusPanel}>
  //         <h1>Invalid onboarding link</h1>
  //         <p>The onboarding link is missing its reference id.</p>
  //       </section>
  //     </main>
  //   );
  // }

  // if (!employeeDetails && !retrieveError) {
  //   return (
  //     <main className={styles.pageShell}>
  //       <section className={styles.statusPanel}>
  //         <h1>Loading onboarding form</h1>
  //         <p>Please wait while we verify your link.</p>
  //       </section>
  //     </main>
  //   );
  // }

  // if (retrieveError || !employeeDetails) {
  //   return (
  //     <main className={styles.pageShell}>
  //       <section className={styles.statusPanel}>
  //         <h1>Invalid onboarding link</h1>
  //         <p>We could not verify this onboarding link.</p>
  //       </section>
  //     </main>
  //   );
  // }

  // if (isRejected) {
  //   return (
  //     <main className={styles.pageShell}>
  //       <section className={styles.statusPanel}>
  //         <h1>Offer letter rejected</h1>
  //         <p>
  //           The onboarding form is available only after accepting the offer
  //           letter.
  //         </p>
  //       </section>
  //     </main>
  //   );
  // }

  // if (isUnsigned || !isSigned) {
  //   return (
  //     <main className={styles.pageShell}>
  //       <section className={styles.statusPanel}>
  //         <h1>Signature required</h1>
  //         <p>
  //           Please complete the offer letter e-signature before filling the
  //           onboarding form.
  //         </p>
  //       </section>
  //     </main>
  //   );
  // }

  return (
    <main className={styles.pageShell}>
      {toast ? <div className={styles.toast}>{toast}</div> : null}
      {/* <img className={styles.logo} src={udsLogo} alt="UDS/" />
      <h1 className={styles.pageTitle}>Employee Information Form</h1> */}

      <div className={styles.pageHeader}>
        <img className={styles.logo} src={Logo} alt="UDS" />
        <h1 className={styles.pageTitle}>Employee Information Form</h1>
      </div>
      <div className={styles.shellWrap}>
        {/* <h1 className={styles.pageTitle}>Employee Form Information</h1> */}

        <div className={styles.timelineWrap}>
          <nav className={styles.timeline} aria-label="Onboarding progress">
            {steps.map((step) => (
              <div
                className={[
                  styles.timelineItem,
                  completedSteps.includes(step)
                    ? styles.completedConnector
                    : "",
                ].join(" ")}
                key={step}
              >
                <button
                  className={[
                    styles.timelineStep,
                    step === activeStep ? styles.activeStep : "",
                    completedSteps.includes(step) ? styles.completedStep : "",
                  ].join(" ")}
                  type="button"
                  onClick={() => handleTimelineClick(step)}
                >
                  {step}
                </button>
              </div>
            ))}
          </nav>
        </div>

        <section className={styles.shellCard}>
          <section className={styles.heroSection} aria-label="Page content">
            {renderActiveStep()}
          </section>

          <footer className={styles.footerActions}>
            {activeStep > 1 ? (
              <button
                className={styles.previousButton}
                type="button"
                onClick={handlePrevious}
              >
                Previous
              </button>
            ) : null}
            <button
              className={styles.continueButton}
              type="button"
              onClick={handleSaveContinue}
            >
              {activeStep === 9 ? "Save & Review" : "Save and Continue"}
            </button>
          </footer>
        </section>
      </div>
    </main>
  );
}
